// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-black[data-v-e315d922]{background-color:#000}.ga-pink[data-v-e315d922]{color:#ff56b1}.text-black[data-v-e315d922]{color:#000}.digitalads-bg[data-v-e315d922]{align-items:center;background-image:url(/img/portfolio/kingscalling/kingscalling-digital-ads.jpg);background-position:50%;background-size:cover;display:flex;height:640px;justify-content:center;width:100%}.kc-logo[data-v-e315d922]{bottom:40px;max-width:240px;position:absolute}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
